import { FilterService } from "src/app/services/filter.service";
import { MixpanelService } from 'src/app/services/mixpanel.service';
import { Component, OnInit, ViewChild, OnDestroy, Input, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import * as _ from "lodash";
import { MatMenuTrigger } from "@angular/material/menu";
import { DashboardService } from "src/app/services/dashboard.service";
import { SessionService } from "src/app/services/session.service";
import { debounceTime, Subscription } from "rxjs";
import { UserActivityService } from "src/app/services/useractivity.service";
import { DeviceDetectionService } from "src/app/services/detectipad.service";
import { Location } from "@angular/common";
import moment from "moment";
import { WidgetService } from "src/app/services/widget.service";
import { NavigationService } from "src/app/services/navigation.service";
import { EnhancementService } from "src/app/services/enhancements-service";
import headerConfig, { GridsterConfig } from "./config";
import { BookmarkService } from "../../shared/bookmark-view/bookmark.service";
import { FloatingChatStateService } from "src/app/services/floating-chat-state.service";

@Component({
  selector: "app-pages",
  templateUrl: "./pages.component.html",
  styleUrls: ["./pages.component.scss"]
})
export class PagesComponent implements OnInit, OnDestroy {
  pagename: any;
  version: any;
  reloadPage = false;
  moment = moment;
  reqSubcription: Subscription[] = [];
  userName: string = "";
  moduleKey: any;
  clientKey: any;
  dashboardKey: any;
  dashboardPages: any = [];
  originalDashboardPages: any = [];
  pages: any;
  selectedTabIndex = 0;
  singlePageFlag = false;
  @Input("widget") widget: any;

  get isSmallScreen(): boolean {
    return this.deviceDetectionService.isTablet || this.deviceDetectionService.isMobile;
  }

  @ViewChild(MatMenuTrigger, { static: true }) matMenuTrigger!: MatMenuTrigger;
  info: any;
  logoImage: any;
  colorCodes: any;
  colors: any;
  selectConfig: any;
  sourceName: any;
  message: any;
  cardName: any;
  cardId: any;
  newColor: any;
  clientLogo: any;
  prName = "";
  selectedType: any;
  configTab = '4';
  showAlerts: boolean = true;
  refreshTheDashboard = false;
  decryptedParams:any;
  historyFlag:any;
  pacard:any;
  notesConfiguration:any;
  schemaConfig:any = '';
  widgetHelpInfo:any;
  moduleName:any;
  bookmarkId:any;
  previousBookmarkId:any;
  isBrandLevelJson = false;
  brandEndpoint = '';

  options: GridsterConfig = headerConfig;
  
  constructor(
    public route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private sessionService: SessionService,
    public dashboardService: DashboardService,
    public filterService: FilterService,
    protected widgetService: WidgetService,
    public deviceDetectionService: DeviceDetectionService,
    private mixpanelService: MixpanelService,
    private navigationService: NavigationService,
    private enhancementService: EnhancementService,
    private bookmarkService: BookmarkService,
    private cdr: ChangeDetectorRef,
    private floatingChatState: FloatingChatStateService,
  ) {
   
    // Route
    this.route.params.subscribe((p: any) => {
      this.cardName = p["cardName"] || '';
      this.moduleName = p['module'] || '';
      this.bookmarkId = p?.['bk_mrk_key'] || undefined;
      if (this.bookmarkId && this.bookmarkId !== this.previousBookmarkId && !isNaN(Number(this.bookmarkId))
      ) {
        this.previousBookmarkId = this.bookmarkId;
        this.bookmarkNavigationUsingUrlId(this.bookmarkId);
      }

      // Query Params
      this.route.queryParams.subscribe((params:any) => {
        this.decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = this.decryptedParams["cl_key"];
        this.moduleKey = this.decryptedParams["md_key"];
        this.dashboardKey = this.decryptedParams["ds_key"];
        this.filterService.dashboardKey = this.decryptedParams["ds_key"];
        this.historyFlag = this.decryptedParams["hist_flg"] || undefined;

        this.pacard = this.decryptedParams["crds"];
        // Tab Level Redirecting
        let tabId = params["tab_id"];
        this.selectedTabIndex = Number(tabId);
      });
      
      // Prescriber Name Header
      if(this.cardName?.toString().replace(/\s+/g, '').toLowerCase() == 'prescribercard') {
        let prName: any = sessionStorage.getItem("navbar_prName");
        this.prName = prName || '';
      } else {
        this.prName = '';
      }
      
      this.pages=[];

      this.selectConfig = sessionStorage.getItem("selectConfig");
      if (!this.selectConfig) this.selectConfig = "S3";
      
      // for user menu icons color css classes.
      this.dashboardService.moduleKey = this.moduleKey;
      
      // patient list Hover Functionality
      this.filterService.hoverBackground = false;

      // filter data is empty when its onload 
      this.filterService.previousFilterModel = {}
      this.userName = this.sessionService.getUsername();
      this.newColor = this.sessionService.getColorCodes();
      
      let brand_key: any = sessionStorage.getItem("brandKeyForFilters");
      
      // patient card Logo 
      let baseQueryPatientStatusChange: any = sessionStorage.getItem("baseQueryPatientStatusChange");
      if(this.pacard && baseQueryPatientStatusChange) {
        let jsn = JSON.parse(baseQueryPatientStatusChange);
        this.clientLogo = this.filterService.getBrandLogo({brand_key: jsn.brand_key});
      } else {
        this.clientLogo = this.filterService.getBrandLogo({brand_key: brand_key});
      }

      // this.clientLogo = this.sessionService.getClintLogo();

      this.loadPageConfig();
      if(!this.dashboardKey) {
        this.getPageLogo();
      }

      this.filterService.logoChange.subscribe((res: any) => {
        this.clientLogo = res.logo
        this.newColor = res.colour_codes?.length == 1 ? res.colour_codes.toString() : "'linear-gradient(to right," + res.colour_codes?.toString() + ")'";
      })
    });
  }


  ngOnInit(): void {
    // in the filter when page load it should be empty - key and name 
    this.filterService.duplicateParameter = {};
    this.filterService.locationPresId = ''

    this.filterService.navigateToPageBrandbased.subscribe((res: any) => {
      if (!this.isBrandLevelJson) return;

      if (this.applyBrandPageKeyFilter(res?.page_key)) {
        this.reloadPage = false;
        this.cdr.detectChanges();
      }

      this.selectedTabIndex = 0;
      this.finalPageConfiguration();
      this.cdr.detectChanges();
    });
  }

  styleLogo(styleLogo: any) {
    return styleLogo;
  }

  // Get Page Logo
  getPageLogo() {
    let req = {
      username: this.userName,
      client_key: this.clientKey,
      module_key: this.moduleKey,
    };
    // const cacheddashboard = sessionStorage.getItem('Scraii_Dashboard');

    // if (cacheddashboard) {
    //   const dashboard = JSON.parse(cacheddashboard);
    //   dashboard.forEach((row: any) => {
    //       if (row.logo_image) {
    //         this.logoImage = row?.logo_image;
    //       }
    //       if (row.color_code) {
    //         this.colorCodes = row?.color_code;
    //       }
    //     });
    //     this.enhancementService.sendAllPageInfoData(dashboard);
    //     return
    //   }
    this.reqSubcription.push(
      this.dashboardService.getDashboardAccess(req).pipe(debounceTime(500)).subscribe((res) => {
        this.info = res ? res : [];

        this.info.forEach((row: any) => {
          if (row.logo_image) {
            this.logoImage = row?.logo_image;
          }
          if (row.color_code) {
            this.colorCodes = row?.color_code;
          }
        });

        this.enhancementService.sendAllPageInfoData(this.info);
        
      }, err => {
        console.log(err)
      })
    );
  }

  // Get Page Access from LoadPageConfig
  loadPageConfig() {
    this.reloadPage = false;
    let req: any = {};
    let body = {
      username: this.userName,
      client_key: this.clientKey,
      dashboard_key: this.dashboardKey,
    };

    const navDetailInfoString = sessionStorage.getItem("navDetailInfo");

    // debugger

    if (navDetailInfoString && this.cardName) {
      let routerPages = JSON.parse(navDetailInfoString);
      req = {};

      if (this.selectConfig == "S3") {
        req['bucketName'] = routerPages['s3JSON'].s3_bucket_nm;
        req['filePath'] = routerPages['s3JSON'].s3_file_path;

        let filepath = routerPages['s3JSON'].s3_file_path
        req['fileName'] = filepath.split("/")[filepath.split("/").length - 1];
        req['module_key'] = this.moduleKey;

        if (routerPages?.['isDashboardLevel']?.toString().toLowerCase() == 'yes') {
          body['dashboard_key'] = routerPages['dbJSON'].work_key;
          this.getPageAccess(body);
        } else {
          this.loadJsonToStringify(req);
        }
      } else {
        req['work_key'] = routerPages['dbJSON'].work_key;
        req['version_number'] = routerPages['dbJSON'].version_number;
        req['ConfigType'] = "DB";
        this.loadJsonToStringify(req);
      }
      // debugger
      let navName:any='';
      if(routerPages['isNavSelected']){
        const value:any = JSON.parse(sessionStorage.getItem("navHeaderData") || '');
        let arr = routerPages['navpageName'].split(",");
        arr.forEach((m:any)=> {
          navName  +=" " + value[m];
      });
      }
      this.pagename =  routerPages['isNavSelected'] ? (routerPages['navpageNameLeft'] + navName + routerPages['navpageNameRight']) : (routerPages['pageName'] || '')

      if(routerPages?.["notes"]?.isNotes) {
        this.dashboardService.dashboardDetailsOfNotes = routerPages?.["notes"];
      } else {
        this.dashboardService.dashboardDetailsOfNotes = {};
      }

    } else {
      this.dashboardService.dashboardDetailsOfNotes = {};
      if (this.selectConfig == "S3") {
        this.getPageAccess(body);
      } else {
        this.getPageDetails(body);
      }
    }
  }

  getPageAccess(body: any) {
    this.reqSubcription.push(
      this.dashboardService.getPageAccess(body).subscribe((dashboard) => {
        if (dashboard.length) {
          this.getPageDetails(dashboard);
        } else {
          if (!this.userName) {
            window.location.href = "/login";
          }
        }
      })
    );
  }

  // Get Page Details
  getPageDetails(pages: any) {
    // debugger
    if (this.selectConfig == "S3") {
      pages.forEach((data: any) => {
        let body = {
          bucketName: data.s3_bucket,
          filePath: data.file_path + "/" + data.file_nm,
          fileName: data.file_nm,
          module_key: this.moduleKey,
        };
        this.loadJsonToStringify(body);
      });
    } else {
      let body = {
        work_key: pages.dashboard_key,
        version_number: 1.0,
        ConfigType: "DB",
      };
      this.loadJsonToStringify(body);
    }
  }

  // Load Json to Stringify
  loadJsonToStringify(page: any) {
    this.reqSubcription.push(
      this.dashboardService.getPageDetails(page).subscribe((response: any) => {
  
        if (page.ConfigType == "DB") {
          response.forEach((data: any) => {
            this.pages.push(this.parsetheStringifyPages(data.LeafElement || []));
          });
        } else {
          this.pages.push(this.parsetheStringifyPages(response[0].LeafElement || []));
        }

        this.dashboardPages = [];
        let dashboardPages = [];
        this.pages.map((m:any)=> JSON.stringify( m.page_config_details))
        
        dashboardPages = _.cloneDeep(this.pages);
        dashboardPages.map((m:any)=> {
          m.page_config_details = JSON.stringify(m.page_config_details);
        })
        
        if(this.historyFlag=='H') {
          dashboardPages = dashboardPages.filter((f:any)=> f.page_key != 2024112504321321);
        }

        this.originalDashboardPages = [...dashboardPages];

        this.brandLevelJsonConfig();

        if (!this.isBrandLevelJson && !this.brandEndpoint) {
          this.dashboardPages = [...this.originalDashboardPages];
          this.finalPageConfiguration(response);
          return;
        }

        // Configurations
        this.refreshIcon();
        this.configurationOfSelectedTab();
        this.notesIcon();

        // Global Configuration for Schema checks and other at the globel level...
        this.schemaChecksConfig();

        setTimeout(() => {
          this.reloadPage = true;
        });

      }, (err) => {
        console.log("Get Page detail", err);
      })
    )
  }

  finalPageConfiguration(response?: any) {
    this.dashboardPages = _.sortBy(this.dashboardPages, "page_seq_no");
    this.dashboardService.getPageKey = _.map(this.dashboardPages, 'page_key');
    if (response?.[0]?.dashboard_key) {
      this.dashboardService.dashboardKey = response[0].dashboard_key;
    }

    if (this.dashboardPages.length > 1) this.filterService.singlePage = false;
    else this.filterService.singlePage = true;


    // This will track the User Event in Mix Panel site
    this.mixpanelService.track(this.moduleName + ' - ' + this.dashboardService.dashboardName + ' - ' + this.dashboardPages[0].page_nm);
    this.selectedTabName = this.dashboardPages[this.selectedTabIndex]?.page_nm;
    this.filterService.pageKey = this.dashboardPages[this.selectedTabIndex]?.page_key

    this.publishPageContext();    
    // Configurations
    this.refreshIcon();
    this.configurationOfSelectedTab();
    this.notesIcon();
    setTimeout(() => {
      this.reloadPage = true;
    });
  }

  bookmarkNavigationUsingUrlId(id:any) {
    
    this.bookmarkService.bookMarkGetBaseQuery(id).subscribe((res:any) => {
      this.filterService.bookmarkFilterData = res?.[0]?.bookmark_value ? JSON.parse(res?.[0]?.bookmark_value) : {};
      // console.log(this.filterService.bookmarkFilterData)
    }, err => {
      console.log("bookmark get id error")
    })
  }
  parsetheStringifyPages(pages: any) {
    for (let idx in pages) {
      if (
        pages[idx].page_config_details == "[]" ||
        pages[idx].page_config_details == ""
      ) {
        pages[idx].page_config_details = [];
      } else {
        pages[idx].page_config_details = JSON.parse(pages[idx].page_config_details || '[]');

        // Find hidden widgets
        const hiddenWidgets = pages[idx].page_config_details.filter(
          (w: any) => w.config?.widget_visibility_flg?.value === 'hide'
        );

        // Only keep visible widgets
        pages[idx].page_config_details = pages[idx].page_config_details.filter(
          (w: any) => w.config?.widget_visibility_flg?.value !== 'hide'
        );
        // Attach hidden widget config to each visible widget
        pages[idx].page_config_details.forEach((widget: any) => {
          let key = widget?.config?.['widgetkey_selection']?.widget_uniq_key;
          const match = hiddenWidgets.find(
            (h: any) => h.widget_uniq_key === key
          );

          // Always store "newItemConfig" outside config (consistent)
          widget.newItemConfig = match || null;
        });

      }
    }
    return pages[0];
  }

  // Selected Tab'
  selectedTabName: any = ''
  seletedTab(event: any, dashboardPages: any) {
    // debugger

    // filter data is empty when its onload 
    this.filterService.previousFilterModel = {}

    this.selectedTabName = dashboardPages[event].page_nm
    this.filterService.pageKey = dashboardPages[event].page_key
    this.publishPageContext();
    let selectedTab = this.dashboardPages[event];
    this.selectedTabIndex = parseInt(event);

    // Re-evaluate the schema toggle for the newly selected tab.
    this.schemaChecksConfig();
    this.mixpanelService.track(this.moduleName + ' - '+this.dashboardService.dashboardName+ ' - '+ selectedTab.page_nm);


    // Tracking Tabs for Payment Calc Record Tab;
    if(this.decryptedParams['tab_id']!=this.selectedTabIndex) {
      if(this.decryptedParams.hasOwnProperty('record')) {
        this.decryptedParams['record'] = 'no';
      }
    }
    
    delete this.decryptedParams['tab_id'];
    const newCryptedObj = Object.assign({}, { tab_id: this.selectedTabIndex }, this.decryptedParams);
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: this.navigationService.encrypedData(newCryptedObj),
      queryParamsHandling: 'merge' // Merge with existing query params
    });
  }

  clickTabChange() {
    // sessionStorage.removeItem('window.colState');
  }

  clickPrescriberList() {
    this.location.back()
  }

  showNotifications() {
    this.showAlerts = false;
  }

  configurationOfSelectedTab() {
    let selectedTab = this.pages?.[0].page_config_details.find((r: any) => r.key == 333333 && r.tabSelection)
    this.configTab = selectedTab ? selectedTab.tabSelection : 4
  }

  refreshIcon() {
    const key = this.pages.find((m: any) => m.page_config_details.find((o: any) => (o.key == 111111 && o.refresh)))
    this.refreshTheDashboard = key ? true : false;
  }

  brandLevelJsonConfig() {
    const widget = this.pages
      ?.flatMap((m: any) => m.page_config_details || [])
      .find((o: any) => o.key == 444444);
    const config = widget?.config;
    this.isBrandLevelJson = !!config?.isBrandLevelJson;
    this.brandEndpoint = config?.brandEndpoint || '';
    this.filterService.isBrandLevelJson = this.isBrandLevelJson;
  }

  applyBrandPageKeyFilter(pageKey: any): boolean {
    if (!pageKey) {
      this.dashboardPages = [...this.originalDashboardPages];
      return false;
    }
    const keys = String(pageKey).split(',').map(k => k.trim()).filter(k => k.length > 0);
    const matched = keys
      .map(k => this.originalDashboardPages.find((p: any) => String(p.page_key) === k))
      .filter((p: any) => !!p);

    if (matched.length > 0) {
      this.dashboardPages = matched;
      return true;
    }
    this.dashboardPages = [...this.originalDashboardPages];
    return false;
  }
  
  notesIcon() {
    const key = this.pages.find((m: any) => m.page_config_details.find((o: any) => (o.key == 101010 && o.isNotes)))
    
    if(key) {
      this.notesConfiguration = key.page_config_details.find((f:any)=> f.key == 101010);
    } else {
      this.notesConfiguration = ''
    } 
  }

  // Schema Checks (Primary / Secondary ...) configuration for the top nav toggle.
  // Evaluated per selected tab, so switching tabs updates the toggle accordingly.
  schemaChecksConfig() {
    const selectedPageKey =
      this.dashboardPages?.[this.selectedTabIndex]?.page_key;

    // dashboardPages keeps page_config_details stringified; this.pages has the
    // parsed config, so match the active tab back to it by page_key.
    const page = this.pages?.find((m: any) => m.page_key == selectedPageKey);
    const details = page?.page_config_details || [];

    const widget = details.find(
      (o: any) => o.key == 555555 && o.config?.isSchemaChecks
    );

    this.schemaConfig = widget?.config?.schemaChecks?.length
      ? widget.config.schemaChecks
      : '';

    // No schema checks on this tab/page — drop any stale value so the
    // interceptor never sends schema_type in a header or payload.
    if (!this.schemaConfig) {
      sessionStorage.removeItem("schema_type");
    }

    const widgetHelpInfo = details.find(
      (o: any) => o.key == 555555 && o.config?.pageInfoChecks
    );
    
    this.widgetHelpInfo = {
      pageInfoChecks: widgetHelpInfo?.config?.pageInfoChecks || false,
      pageInfoVar: widgetHelpInfo?.config?.pageInfoVar || '',
      pageInfoApiKey: widgetHelpInfo?.config?.pageInfoApiKey || '',
      pageInfoWidgetKey: widgetHelpInfo?.config?.pageInfoWidgetKey || '',
    }
  }

  // Destroy All Subscription
  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
    this.floatingChatState.clearActiveDashboardPages();
    // Leaving the dashboard pages — clear schema selection so it is not sent elsewhere.
    sessionStorage.removeItem("schema_type");
  }

  private publishPageContext(): void {
    if (!this.dashboardPages?.length) {
      return;
    }

    this.floatingChatState.publishActiveDashboardPages({
      dashboardKey: this.dashboardKey ?? null,
      pages: this.dashboardPages.map((page: any) => ({
        page_key: page.page_key,
        page_nm: page.page_nm,
      })),
      activeTabIndex: this.selectedTabIndex,
    });
  }
}
